<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="要货计划详情"
      width="1400px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="plan"
        class="form"
        label-width="100px">
      <table class="gridtable" style="width: 100%">
        <tr>
          <td class="tableLabel">单号:</td>
          <td style="width: 50%">{{plan.billNo}}</td>
          <td class="tableLabel">标题:</td>
          <td style="width: 50%">{{plan.billTitle}}</td>
        </tr>
      </table>
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="物料信息" name="first">
          <el-table
              :data="plan.details"
              border
              style="width: 100%">
            <el-table-column
                prop="purchaseOrderNo"
                align="center"
                label="采购订单"
                show-overflow-tooltip
                width="100"/>
            <el-table-column prop="rowIndex" align="center" label="行号" width="80"/>
            <el-table-column
                prop="materialNo"
                align="center"
                label="物料编号"
                show-overflow-tooltip
                width="120"/>
            <el-table-column
                prop="materialDesc"
                align="left"
                label="物料描述"
                min-width="120"
                show-overflow-tooltip/>
            <el-table-column prop="quantity" align="center" label="本次要货数量" width="100"/>
            <el-table-column prop="actualQuantity" align="center" label="实收数量" width="100"/>
            <el-table-column prop="note" align="center" label="备注" width="120"/>
            <el-table-column prop="requireDeliveryDate" align="center" label="需求日期" width="120">
              <template v-slot="scope">
                <span>{{scope.row.requireDeliveryDate.slice(0,10)}}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="deliveryDate"
                align="center"
                label="回复交期"
                width="180">
              <template v-slot="scope">
                <el-date-picker
                    v-if="(plan.status === 0 || plan.status === 1) && scope.row.status !== 30"
                    v-model="scope.row.deliveryDate"
                    :disabled="userType === 1"
                    style="width: 150px"
                    align="center"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="date"
                    placeholder="选择日期"/>
                <span v-else>{{scope.row.deliveryDate.slice(0,10)}}</span>
              </template>
            </el-table-column>
            <el-table-column
                v-if="plan.status === 2"
                label="交期确认"
                align="center"
                width="180">
              <template v-slot="scope">
                <el-radio-group v-model="scope.row.status" :disabled="userType === 2">
                  <el-radio :label="10">退回</el-radio>
                  <el-radio :label="30">确认</el-radio>
                </el-radio-group>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <template>
        <el-button
            v-if="plan.status < 2"
            :disabled="userType === 1"
            type="primary"
            :loading="saveLoading"
            @click="handleSave">保存</el-button>
        <el-button
            v-if="plan.status < 5"
            :disabled="submitDisable"
            type="warning"
            :loading="submitLoading"
            @click="handleSubmit">提交</el-button>
      </template>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import LoginUtil from "@/util/loginUtil";

  export default {
    components: {},
    data() {
      return {
        userType:LoginUtil.getUserType(),
        activeName: "first",
        dialogVisible: false,
        saveLoading: false,
        submitLoading: false,
        submitDisable: true,
        plan: {
          details: [],
        },
      };
    },
    methods: {
      open(row) {
        this.plan.pkId = row.pkId;
        this.getData();
      },
      getData() {
        this.$http
          .get("basic", `purchasePlans/${this.plan.pkId}`)
          .then(resp => {
            resp.details.forEach(detail => {
              if (detail.deliveryDate === null) {
                detail.deliveryDate = detail.requireDeliveryDate;
              }
            });
            this.plan = resp;
            this.dialogVisible = true;
            if (this.plan.status < 2) {
              this.submitDisable = this.userType === 1;
            } else if (this.plan.status === 2) {
              this.submitDisable = this.userType === 2;
            }
          });
      },
      handleSave() {
        this.saveLoading = true;
        console.log(this.plan);
        this.$http
          .put("basic", "purchasePlans/responseDeliveryTime", this.plan)
          .then(() => {
            this.saveLoading = false;
            this.dialogVisible = false;
            this.$emit("save-success");
            this.$message.success("保存成功");
          })
          .catch(() => {
            this.saveLoading = false;
          });
      },
      handleSubmit() {
        this.submitLoading = true;
        this.$http
          .post("basic", "purchasePlans/responseDeliveryTime", this.plan)
          .then(() => {
            this.submitLoading = false;
            this.dialogVisible = false;
            this.$emit("save-success");
            this.$message.success("提交成功");
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },
    },
  };
</script>

<style>
table.gridtable {
  font-family: verdana,arial,sans-serif;
  font-size:11px;
  color:#333333;
  border: 1px solid #EBEEF5;
  border-bottom: none;
  border-left: none;
  margin-bottom: 15px;
}
table.gridtable tr td {
  padding: 8px;
  border-left: 1px solid #EBEEF5;
  border-bottom: 1px solid #EBEEF5;
}
.tableLabel {
  width: 8%;
  text-align: right;
  background-color: #D1E6F5;
  border-left: 1px solid #EBEEF5;
}
</style>
